export default __webpack_public_path__ + "static/media/SparkAR.b4207e98.webp";